import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';
import { IUser, defaultValue } from 'app/shared/model/user.model';

export const ACTION_TYPES = {
  FETCH_USER: 'userManagement/FETCH_USER',
  UPDATE_USER: 'userManagement/UPDATE_USER',
  RESET: 'userManagement/RESET'
};

const initialState = {
  loading: false,
  errorMessage: null,
  users: [] as ReadonlyArray<IUser>,
  authorities: [] as any[],
  user: defaultValue,
  updating: false,
  updateSuccess: false,
  updateFailure: false,
  totalItems: 0,
  userInfo: {} as any,
  baseResponse: {} as any
};

export type UserManagementState = Readonly<typeof initialState>;

// Reducer
export default (state: UserManagementState = initialState, action): UserManagementState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_USER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updateFailure: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.UPDATE_USER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updateFailure: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_USER):
      return {
        ...state,
        loading: false,
        updating: false,
        errorMessage: action.payload
      };
    case FAILURE(ACTION_TYPES.UPDATE_USER):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        updateFailure: true
      };
    case SUCCESS(ACTION_TYPES.FETCH_USER):
      return {
        ...state,
        loading: false,
        userInfo: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.UPDATE_USER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        baseResponse: action.payload.data
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/users';
// Actions

// export const getUser: ICrudGetAction<IUser> = id => {
//   const requestUrl = `${apiUrl}/${id}`;
//   return {
//     type: ACTION_TYPES.FETCH_USER,
//     payload: axios.get<IUser>(requestUrl)
//   };
// };
export const getUser = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_USER,
    payload: axios.get(requestUrl)
  };
};

export const updateUser: ICrudPutAction<IUser> = user => dispatch => {
  const result = dispatch({
    type: ACTION_TYPES.UPDATE_USER,
    payload: axios.put(apiUrl, user)
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
